<div [attr.role]="silent ? null : 'alert'" cignaTestTag="spinner">
  <div class="loading-spinner spinner-{{ size }}"></div>
  <div class="mt-s small-text text-gray-40">{{ hint }}</div>
</div>
